import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice du Volume Sph\u00e8re";
const DESCRIPTION =
  "Calculatrice du volume de la sph\u00e8re : calculez le volume d'une sph\u00e8re en fonction du rayon. Obtenez un r\u00e9sultat pr\u00e9cis et imm\u00e9diat avec la formule V = (4/3) \u00d7 \u03c0 \u00d7 r\u00b3.";
const KEYWORDS =
  "volume sph\u00e8re, calculatrice volume sph\u00e8re, calcul volume sph\u00e8re, rayon sph\u00e8re, formule volume sph\u00e8re";
const OG_URL = "https://do-calculate.com/calculator/fr/sphere-volume";
function SphereVolumeCalculator() {
  const [radius, setRadius] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!radius) {
      setError("Veuillez entrer une valeur pour le rayon.");
      setResult("");
      return;
    }
    const r = parseFloat(radius);
    if (isNaN(r) || r <= 0) {
      setError("Veuillez entrer une valeur positive valide pour le rayon.");
      setResult("");
      return;
    }
    const volume = ((4 / 3) * Math.PI * r * r * r).toFixed(2);
    setResult(volume);
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer le volume d'une sph\u00e8re</h2>
                <p>
                  Le volume d'une sph\u00e8re peut \u00eatre calcul\u00e9 \u00e0 partir du rayon gr\u00e2ce \u00e0 la formule suivante :
                </p>
                <p>
                  <strong>Volume de la sph\u00e8re = (4/3) \u00d7 \u03c0 \u00d7 (rayon)\u00b3</strong>
                </p>
                <p>
                  Veuillez entrer la valeur du rayon pour calculer le volume de la sph\u00e8re.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Rayon (cm)</label></b>
                    <input
                      type="number"
                      placeholder="Rayon"
                      value={radius}
                      onChange={(e) => setRadius(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer le volume
                  </button>
                </div>
                <br />
                <div>
                  {error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">Erreur : {error}</p>
                  ) : (
                    <>
                      {result !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Volume de la sph\u00e8re : {result} cm\u00b3
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Qu'est-ce que le volume d'une sph\u00e8re ?</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Concept du volume d'une sph\u00e8re</h2></u>
                  <p>
                    Le volume d'une sph\u00e8re repr\u00e9sente l'espace tridimensionnel occup\u00e9 \u00e0 l'int\u00e9rieur de celle-ci. Il est utilis\u00e9 dans de nombreuses applications en g\u00e9om\u00e9trie, physique et ing\u00e9nierie.
                  </p>
                  <ul>
                    <li><strong>Volume = (4/3) \u00d7 \u03c0 \u00d7 r\u00b3</strong></li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si le rayon est 5 cm, le volume est : (4/3) \u00d7 \u03c0 \u00d7 5\u00b3 \u2248 523,60 cm\u00b3
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Comment calculer le volume d'une sph\u00e8re</h2></u>
                  <p>Pour calculer le volume d'une sph\u00e8re, suivez ces \u00e9tapes :</p>
                  <ul>
                    <li>Mesurez ou notez le rayon de la sph\u00e8re.</li>
                    <li>Calculez le cube du rayon (r\u00b3).</li>
                    <li>Multipliez par (4/3) \u00d7 \u03c0.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si le rayon est 3 cm, le volume est : (4/3) \u00d7 \u03c0 \u00d7 27 \u2248 113,10 cm\u00b3
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Questions fr\u00e9quentes</h2></u>
                  <div className="p-3 mb-2 bg-info text-black">
                    Question : Quelle est la diff\u00e9rence entre le rayon et le diam\u00e8tre d'une sph\u00e8re ?
                    <br />
                    R\u00e9ponse : Le rayon est la distance du centre \u00e0 la surface. Le diam\u00e8tre est le double du rayon. Dans la formule, on utilise le rayon.
                  </div>
                  <div className="p-3 mb-2 bg-info text-black" style={{ marginTop: "10px" }}>
                    Question : \u00e0 quoi sert le calcul du volume d'une sph\u00e8re ?
                    <br />
                    R\u00e9ponse : Il est utilis\u00e9 pour calculer la capacit\u00e9 de r\u00e9servoirs sph\u00e9riques, le volume de ballons, de plan\u00e8tes et d'autres objets de forme sph\u00e9rique.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SphereVolumeCalculator;
